// extracted by mini-css-extract-plugin
export default {"eyebrow":"Eyebrow_eyebrow__6MFac","light":"Eyebrow_light__X73tQ"};